 <template>
  <v-form ref="contactEditForm" v-model="valid" class="contact-page">
    <v-row>
      <v-col cols="12">
        <h1>Контакты</h1>
      </v-col>

      <v-col  cols="12" sm="6" md="5" xl="4">
        <v-tabs v-model="tab">
          <v-tab>Описание</v-tab>
          <v-tab>Телефоны</v-tab>
          <v-tab>Соц. сети</v-tab>
          <v-tab>График работы</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" class="pt-6">
          <v-tab-item>
            <v-tabs v-model="tabLang">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabLang">
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-textarea
                        v-model="contact.description"
                        label="Описание"
                        outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-textarea
                        v-model="contact.description_ua"
                        label="Описание"
                        outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-tab-item>
          <v-tab-item>
            <v-text-field
                v-model="contact.phone_1"
                label="Odessa"
                outlined
            >
              <template v-slot:append>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.89089 0.544209C5.67799 -1.88388 10.0787 4.49853 8.02502 6.23288L6.77816 7.34286C5.38461 8.52222 13.1591 16.5696 14.5527 15.3209L15.7995 14.2109C17.7799 12.4765 24.0875 17.194 21.3004 19.6221L19.4668 21.2177C13.9659 26.0738 -4.59026 6.92662 1.05728 2.13981L2.89089 0.544209Z" fill="#FD942E"/>
                </svg>
              </template>
            </v-text-field>
            <v-text-field
                v-model="contact.phone_2"
                label="Lifecell"
                outlined
            >
              <template v-slot:append>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0 10.983C0.00359212 8.65972 0.742686 6.39724 2.11132 4.5199C3.47996 2.64256 5.40787 1.24676 7.61865 0.532596C9.82943 -0.181565 12.2096 -0.17741 14.4178 0.544464C16.6261 1.26634 18.5491 2.66886 19.9112 4.55097C21.2733 6.43308 22.0045 8.69813 22 11.0214C21.9954 13.3447 21.2555 15.6068 19.8861 17.4836C18.5167 19.3604 16.5882 20.7555 14.3772 21.4688C12.1661 22.182 9.78595 22.1769 7.57796 21.4542C8.3613 16.907 11.232 13.199 15.0264 11.6242C15.4017 12.0597 15.9181 12.3495 16.4854 12.4429C17.0527 12.5362 17.6347 12.4273 18.1298 12.135C18.6249 11.8428 19.0015 11.3859 19.1939 10.8441C19.3863 10.3023 19.3821 9.71017 19.1822 9.17115C18.9822 8.63213 18.5992 8.18052 18.1001 7.89525C17.601 7.60997 17.0174 7.50919 16.4515 7.6105C15.8856 7.71182 15.3733 8.00879 15.0041 8.44951C14.635 8.89023 14.4324 9.44668 14.4319 10.0216C9.58981 11.4749 5.66593 14.8547 3.67476 19.195C3.04256 18.6325 2.4776 17.9988 1.99117 17.3064C2.10539 13.0794 4.19729 9.37854 7.33154 7.19941C7.7122 7.62768 8.23094 7.90898 8.79753 7.99437C9.36413 8.07976 9.94273 7.96384 10.4327 7.66678C10.9227 7.36973 11.293 6.91032 11.4793 6.36846C11.6656 5.8266 11.6561 5.23658 11.4524 4.70101C11.2488 4.16545 10.8638 3.71822 10.3645 3.43711C9.86519 3.15601 9.28315 3.05881 8.7196 3.16243C8.15606 3.26605 7.64666 3.56392 7.28001 4.00425C6.91335 4.44457 6.71264 4.99949 6.71278 5.57248C6.71278 5.64353 6.71278 5.71637 6.72267 5.78293C3.80427 6.80729 1.40839 8.83354 0.007195 11.4138C1.64837e-07 11.2744 0 11.1296 0 10.9875" fill="#FFC10E"/>
                </svg>
              </template>
            </v-text-field>
            <v-text-field
                v-model="contact.phone_3"
                label="Vodafone"
                outlined
            >
              <template v-slot:append>
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21.998 11.8672C21.998 17.9421 17.075 22.8672 11 22.8672C4.92504 22.8672 0 17.9421 0 11.8672C0 5.79222 4.92504 0.867188 11 0.867188C17.075 0.867188 21.998 5.79222 21.998 11.8672Z" fill="#EE3023"/>
                  <path d="M11.0844 18.0033C8.06308 18.0136 4.91849 15.4347 4.90435 11.2918C4.89423 8.55343 6.37357 5.91609 8.26114 4.35188C10.1042 2.82809 12.6284 1.84792 14.9161 1.83984C15.2112 1.83984 15.5204 1.86405 15.7083 1.92873C13.7076 2.34302 12.1151 4.20632 12.1211 6.31822C12.1211 6.38891 12.1272 6.4637 12.1352 6.49807C15.4839 7.31454 17.0037 9.33548 17.0138 12.1304C17.0218 14.9274 14.815 17.9912 11.0843 18.0033" fill="white"/>
                </svg>
              </template>
            </v-text-field>
            <v-text-field
                v-model="contact.phone_4"
                label="Kyivstar"
                outlined
            >
              <template v-slot:append>
                <svg width="22" height="22" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13 2V8.2978V2Z" fill="black"/>
                  <path d="M13 2V8.2978" stroke="#00A0FF" stroke-width="2.53333" stroke-linecap="round"/>
                  <path d="M24 10.4023L18.3034 12.3485L24 10.4023Z" fill="black"/>
                  <path d="M24 10.4023L18.3034 12.3485" stroke="#00A0FF" stroke-width="2.53333" stroke-linecap="round"/>
                  <path d="M19.7998 24L16.2791 18.905L19.7998 24Z" fill="black"/>
                  <path d="M19.7998 24L16.2791 18.905" stroke="#00A0FF" stroke-width="2.53333" stroke-linecap="round"/>
                  <path d="M6.20508 24L9.72575 18.905L6.20508 24Z" fill="black"/>
                  <path d="M6.20508 24L9.72575 18.905" stroke="#00A0FF" stroke-width="2.53333" stroke-linecap="round"/>
                  <path d="M2 10.4023L7.69656 12.3485L2 10.4023Z" fill="black"/>
                  <path d="M2 10.4023L7.69656 12.3485" stroke="#00A0FF" stroke-width="2.53333" stroke-linecap="round"/>
                </svg>
              </template>
            </v-text-field>
          </v-tab-item>
          <v-tab-item>
            <v-text-field
                v-model="contact.viber"
                label="Viber"
                outlined
            >
              <template v-slot:append>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.7857 22C21.4561 22 21.9998 21.4563 21.9998 20.7857V1.21422C21.9998 0.543515 21.4562 0 20.7857 0H1.21422C0.543515 0 0 0.543515 0 1.21422V20.7857C0 21.4562 0.543429 22 1.21422 22H20.7857Z" fill="#3C5A99"/>
                  <path d="M20.7857 22C21.4561 22 21.9998 21.4563 21.9998 20.7857V1.21422C21.9998 0.543515 21.4562 0 20.7857 0H1.21422C0.543515 0 0 0.543515 0 1.21422V20.7857C0 21.4562 0.543429 22 1.21422 22H20.7857Z" fill="#7360F2"/>
                  <path d="M16.3068 4.56061C15.9138 4.19374 14.3255 3.02733 10.7876 3.01148C10.7876 3.01148 6.61552 2.75698 4.5817 4.64417C3.44956 5.78969 3.0513 7.46583 3.00929 9.54389C2.96727 11.622 2.91292 15.5164 6.62383 16.5724H6.62739L6.62501 18.1837C6.62501 18.1837 6.60128 18.836 7.02589 18.969C7.53951 19.1304 7.84094 18.6346 8.33129 18.1001C8.60044 17.8067 8.97213 17.3757 9.2522 17.0463C11.7901 17.2624 13.7421 16.7685 13.9638 16.6955C14.4762 16.5275 17.3758 16.1517 17.8474 12.2575C18.3342 8.24375 17.612 5.70493 16.3068 4.56061Z" fill="white"/>
                  <path d="M15.4828 5.37165C15.1505 5.06624 13.7162 4.15458 10.7235 4.14138C10.7235 4.14138 7.17973 3.90584 5.45945 5.4821C4.50199 6.43842 4.17944 7.86053 4.14408 9.59597C4.10871 11.3314 3.92548 14.6467 7.06343 15.5286C7.06343 15.5286 7.05109 17.9899 7.04967 18.2062C7.04967 18.3575 7.0734 18.461 7.15884 18.4823C7.22032 18.4975 7.31241 18.4653 7.39073 18.3863C7.89248 17.8766 9.49884 15.9161 9.49884 15.9161C11.6542 16.0585 13.369 15.628 13.5534 15.567C13.9882 15.4256 16.3401 15.2213 16.7381 11.9689C17.1495 8.61637 16.5869 6.32797 15.4828 5.37165Z" fill="#7360F2"/>
                  <path d="M12.2446 9.45381C12.2057 8.66004 11.8071 8.24314 11.0488 8.20312" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M13.269 9.80223C13.2848 9.06272 13.0683 8.44486 12.6194 7.94866C12.1684 7.45069 11.5442 7.17649 10.7432 7.11719" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14.3211 10.2173C14.3115 8.934 13.9324 7.92334 13.184 7.18527C12.4355 6.44721 11.5048 6.07425 10.3916 6.06641" stroke="white" stroke-width="0.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M11.0882 12.1649C11.0882 12.1649 11.3695 12.189 11.5209 12.0002L11.8162 11.6245C11.9586 11.4382 12.3022 11.3193 12.6388 11.509C12.891 11.6545 13.1359 11.8127 13.3724 11.9829C13.5958 12.1491 14.0531 12.5352 14.0546 12.5352C14.2725 12.7213 14.3228 12.9945 14.1744 13.2826C14.1744 13.2843 14.1732 13.2872 14.1732 13.2886C14.0099 13.5751 13.8024 13.8335 13.5588 14.054C13.5559 14.0555 13.5559 14.0569 13.5533 14.0584C13.3416 14.2373 13.1336 14.339 12.9293 14.3635C12.8992 14.3689 12.8687 14.3708 12.8382 14.3693C12.7481 14.3702 12.6585 14.3562 12.5728 14.328L12.5662 14.3182C12.2515 14.2284 11.726 14.0036 10.8509 13.5153C10.3445 13.236 9.86236 12.9138 9.40971 12.5522C9.18283 12.3711 8.96641 12.1769 8.76152 11.9707L8.73968 11.9486L8.71785 11.9265L8.69601 11.9044C8.68865 11.8972 8.68153 11.8898 8.67418 11.8823C8.47032 11.6751 8.27839 11.4561 8.09932 11.2266C7.74193 10.7688 7.42346 10.2812 7.14733 9.76898C6.66457 8.88349 6.44241 8.35239 6.35364 8.03353L6.34391 8.02681C6.31609 7.94015 6.30238 7.84949 6.30333 7.75838C6.30167 7.72754 6.3035 7.6966 6.30879 7.66618C6.33426 7.45985 6.43498 7.24929 6.61093 7.03448C6.61235 7.03184 6.61378 7.03184 6.6152 7.02896C6.83316 6.78245 7.08858 6.57269 7.37186 6.40758C7.37328 6.40758 7.37613 6.40613 7.37779 6.40613C7.66261 6.25607 7.93271 6.30697 8.11641 6.52618C8.11784 6.52763 8.49878 6.9903 8.66231 7.21623C8.83064 7.45579 8.98701 7.70372 9.13083 7.9591C9.31833 8.29933 9.20085 8.64771 9.01667 8.79129L8.64522 9.08998C8.45772 9.24316 8.4824 9.52768 8.4824 9.52768C8.4824 9.52768 9.03257 11.6341 11.0882 12.1649Z" fill="white"/>
                </svg>

              </template>
            </v-text-field>
            <v-text-field
                v-model="contact.telegram"
                label="Telegram"
                outlined
            >
              <template v-slot:append>
                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z" fill="url(#paint0_linear)"/>
                  <path d="M20.7857 22C21.4561 22 21.9998 21.4563 21.9998 20.7857V1.21422C21.9998 0.543515 21.4562 0 20.7857 0H1.21422C0.543515 0 0 0.543515 0 1.21422V20.7857C0 21.4562 0.543429 22 1.21422 22H20.7857Z" fill="#3C5A99"/>
                  <path d="M20.7857 22C21.4561 22 21.9998 21.4563 21.9998 20.7857V1.21422C21.9998 0.543515 21.4562 0 20.7857 0H1.21422C0.543515 0 0 0.543515 0 1.21422V20.7857C0 21.4562 0.543429 22 1.21422 22H20.7857Z" fill="#0088CC"/>
                  <path d="M9.16757 13.2383L13.6006 16.5134C14.1065 16.7926 14.4715 16.648 14.5975 16.0438L16.402 7.54055C16.5867 6.79988 16.1197 6.46383 15.6357 6.68356L5.03991 10.7692C4.31666 11.0594 4.32097 11.4629 4.90809 11.6426L7.6272 12.4914L13.9222 8.51991C14.2194 8.3397 14.4922 8.4365 14.2684 8.63523" fill="url(#paint1_linear)"/>
                  <defs>
                    <linearGradient id="paint0_linear" x1="14.674" y1="3.674" x2="9.174" y2="16.5" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#37AEE2"/>
                      <stop offset="1" stop-color="#1E96C8"/>
                    </linearGradient>
                    <linearGradient id="paint1_linear" x1="12.3763" y1="11.0016" x2="14.0929" y2="14.9129" gradientUnits="userSpaceOnUse">
                      <stop stop-color="#EFF7FC"/>
                      <stop offset="1" stop-color="white"/>
                    </linearGradient>
                  </defs>
                </svg>

              </template>
            </v-text-field>
            <v-text-field
                v-model="contact.facebook"
                label="Facebook"
                outlined
            >
              <template v-slot:append>
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.7853 21.9996C21.4557 21.9996 21.9994 21.4559 21.9994 20.7853V1.2142C21.9994 0.543504 21.4558 0 20.7853 0H1.2142C0.543504 0 0 0.543504 0 1.2142V20.7853C0 21.4558 0.543418 21.9996 1.2142 21.9996H20.7853Z" fill="#3C5A99"/>
                  <path d="M15.1803 22.0011V13.4817H18.0399L18.4681 10.1615H15.1803V8.04178C15.1803 7.08051 15.4473 6.42544 16.8257 6.42544L18.5838 6.42467V3.45508C18.2798 3.41462 17.2361 3.32422 16.0219 3.32422C13.4871 3.32422 11.7517 4.8715 11.7517 7.71297V10.1615H8.88477V13.4817H11.7517V22.0011H15.1803Z" fill="white"/>
                </svg>

              </template>
            </v-text-field>
            <v-text-field
                v-model="contact.instagram"
                label="Instagram"
                outlined
            >
              <template v-slot:append>

              </template>
            </v-text-field>
          </v-tab-item>
          <v-tab-item>
            <v-row>
            <template v-for="(day, index) in contact.schedule">
              <v-col cols="12" class="title pt-0 pb-0">{{ day.title}}</v-col>
              <v-col cols="4">
                <v-text-field
                    v-model="day.time_start"
                    label="Конец рабочего дня"
                    v-mask="'##:##'"
                    outlined
                    :disabled="day.day_off"
                    hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field
                    v-model="day.time_end"
                   v-mask="'##:##'"
                    label="Конец рабочего дня"
                    hide-details
                    outlined
                    :disabled="day.day_off"
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-checkbox v-model="day.day_off"
                            label="Выходной"
                            hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12"><v-divider></v-divider></v-col>

            </template>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
        <v-btn @click="update">Сохранить</v-btn>
      </v-col>
      <v-snackbar
              v-model="snackbar"
              :timeout="timeout"
              :color="snackbarColor"
              right
              top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
  // @ is an alias to /src
  import PageService from './../../api/PageService'


  export default {
    name: 'Contact',
    props: {
    },
    components: {},
    data: () => ({
      snackbar: false,
      timeout: 2000,
      mask: 'credit-card',
      snackbarText: '',
      timeModal: false,
      snackbarColor: '',
      rules: {
        required: value => !!value || 'Нужно заполнить',
        requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
      },
      valid: true,
      tab: '',
      tabLang: '',
      contact: {
        phone_1: '',
        phone_2: '',
        phone_3: '',
        phone_4: '',
        description: '',
        description_ua: '',
        viber: '',
        telegram: '',
        facebook: '',
        instagram: '',
        schedule: [
          {
            title: 'Понедельник',
            time_start: '',
            time_end: '',
            day_off: false
          },
          {
            title: 'Вторник',
            time_start: '',
            time_end: '',
            day_off: false
          },
          {
            title: 'Среда',
            time_start: '',
            time_end: '',
            day_off: false
          },
          {
            title: 'Четверг',
            time_start: '',
            time_end: '',
            day_off: false
          },
          {
            title: 'Пятница',
            time_start: '',
            time_end: '',
            day_off: false
          },
          {
            title: 'Субота',
            time_start: '',
            time_end: '',
            day_off: false
          },
          {
            title: 'Воскресенье',
            time_start: '',
            time_end: '',
            day_off: true
          }
        ]
      },
      loading: true,
      loadingButton: false,
    }),
    mounted() {
            PageService.getContact()
                .then(response => {
                    this.contact = response.data;
                    this.loading = false
                });
    },
    methods: {
      validate() {


      },
      previewImage(isList, image) {
        if(this.image && this.image.url){
            return this.image.url
        }
        if(image){
          return URL.createObjectURL(image)
        }
      },
      update(){

        this.loadingButton = true;
        let formData = this.getData();

        PageService.updateContact(formData).then(response => {
          this.snackbar = true;
          this.snackbarText = 'Страница успешно обновлена';
          this.snackbarColor = 'success';
        }).catch(error => {
          this.snackbar = true;
          this.snackbarText = 'Ошибка при обновлении страницы';
          this.snackbarColor = 'error';
        }).finally(() => {
          this.loadingButton = false
        })
      },
      getData() {
          let formData = new FormData();

          formData.append('phone_1', this.contact.phone_1);
          formData.append('phone_2', this.contact.phone_2);
          formData.append('phone_3', this.contact.phone_3);
          formData.append('phone_4', this.contact.phone_4);
          formData.append('viber', this.contact.viber);
          formData.append('schedule', JSON.stringify(this.contact.schedule));
          formData.append('telegram', this.contact.telegram);
          formData.append('facebook', this.contact.facebook);
          formData.append('instagram', this.contact.instagram);
          formData.append('description', this.contact.description);
          formData.append('description_ua', this.contact.description_ua);

          return formData;
      }
    },
  }
</script>

<style lang="scss">
  .contact-page{
    .v-input__append-inner{
      margin-top: 13px!important;
    }
  }
</style>

<style scoped lang="scss">
  .contact-images .v-image{
    max-height: 374px;
  }
  .mobile{
    width: 300px;
    height: 300px;
    margin-bottom: 24px;
  }
  .contact{
    position: relative;
    .title{
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #5D6670;
      display: flex;
      justify-content: space-between;
    }
    &:before{
      content: "";
      padding-top: 100%;
      display: block;
    }

    .content{
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      height: 100%;
      background-color: #F8FBFF;
      border-right-style: 3px;
      .img{
        height: 3.541vw;
        margin-top: .83vw;
      }
      .name{
        margin-top: .72vw;
        text-align: center;
        color: #8C959D;
      }
    }
  }
</style>
